<template>
  <div
    class="c-progress-bar"
    :class="{ 'c-progress-bar--fill': $parent.isEmbedded }"
  >
    <ui-popover
      ref="popover"
      class="c-progress-bar__wrapper"
      @hover="hover"
    >
      <template #wrapper>
        <ui-track-bar
          :value="progress"
          :ads-cue-points="adsCuePointsInPercents"
          @changed="seek"
        ></ui-track-bar>
      </template>
      <template #content>
        <div class="c-progress-bar__popover">
          <ui-player-sprite
            v-if="sprites || manifest.sprites"
            :hover-time="isCatchup ? hoverTimeFromUnixZeroSec : hoverTimeFromProgramStart"
            :sprites="sprites || manifest.sprites"
            :sprite-url="spriteUrl"
            :preview-day="previewDay"
            :is-channel="isCatchup"
          ></ui-player-sprite>
          <div class="u-mt-5 u-text-center">
            {{ hoverTimeFromProgramStart | timeFormatExclusive }}
          </div>
        </div>
      </template>
    </ui-popover>
  </div>
</template>
<script>
  import { setSeekTo, state } from '@/shared/components/player/store';
  import { timeFormatExclusive } from '@/index/shared/filters';
  import UiTrackBar from '@/shared/components/track-bar/index.vue';
  import UiPopover from '@/shared/components/popover/index.vue';
  import UiPlayerSprite from '@/shared/components/player/components/sprite/index.vue';
  import { ChannelSprites } from '@/shared/components/player/mixins';

  export default {
    name: 'UiPlayerProgressBar',
    components: { UiPlayerSprite, UiPopover, UiTrackBar },
    filters: {
      timeFormatExclusive,
    },
    mixins: [
      ChannelSprites,
    ],
    data() {
      return {
        hoverTimeFromProgramStart: 0,
        hoverTimeFromUnixZeroSec: 0,
      };
    },
    computed: {
      adsCuePointsInPercents() {
        return state.adsCuePoints
          .map(({ time }) => ({
            percent: (time / this.duration) * 100,
          }));
      },
      manifest() {
        return state.spriteManifest;
      },
      spriteUrl() {
        return this.isCatchup ? this.previewUrl : state.spriteBaseUrl;
      },
      duration() {
        return state.duration;
      },
      progress() {
        const progress = (state.progress / this.duration) * 100;
        if (progress >= 100) {
          return 100;
        }

        if (progress <= 0) {
          return 0;
        }

        return progress;
      },
    },
    methods: {
      seek(clickPosition) {
        setSeekTo((clickPosition * this.duration) / 100);
      },
      hover({ left, offsetWidth }) {
        this.hoverTimeFromProgramStart = (left / offsetWidth) * this.duration;
        this.hoverTimeFromUnixZeroSec = this.product.since / 1000 + this.hoverTimeFromProgramStart;

        if (this.isCatchup && this.previewUrl) {
          this.getChannelSprite();
        }
      },
    },
  };
</script>
